// const API_BASE_URL = "http://localhost:8081/api/v1";
// const API_BASE_URL = "https://6492-157-119-203-125.ngrok-free.app/api/v1";
// const API_BASE_URL = "https://ecommerce-451118.df.r.appspot.com/api/v1";
const API_BASE_URL = "https://ecommerce-ni11.onrender.com/api/v1";

export const API_ENDPOINTS = {
    REGISTER: `${API_BASE_URL}/user/register`,
    LOGIN: `${API_BASE_URL}/auth/login`,
    PROFILE: `${API_BASE_URL}/user/profile`, // Example secured route
    PRODUCTLIST: `${API_BASE_URL}/products/getAllProducts`,
    PRODUCT_DETAILS: `${API_BASE_URL}/products`,
    ADD_TO_CART: `${API_BASE_URL}/cart/addCart`,
    GET_CART: `${API_BASE_URL}/cart/getCart`, // Fetch cart items
    REMOVE_FROM_CART: `${API_BASE_URL}/cart/delete`,
    PLACE_ALL_ORDER: `${API_BASE_URL}/orders/placeAllOrders`, // Place order
    PLACE_SINGLE_ORDER: `${API_BASE_URL}/orders/placeSingleOrder`, // Place order

    LOGOUT: `${API_BASE_URL}/auth/logout`,
    ADD_FEEDBACK: `${API_BASE_URL}/feedBack/addFeedBack`,
    VERIFY_PAYMENT: `${API_BASE_URL}/payment/verify`
};
